<!-- ----------------------------------------------- -->
<template>
  <div>
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 180 300"
      width="180"
      height="300"
    >
      <defs>
        <path d="M5 5L30 5L30 30L5 30L5 5Z" id="fldctlDispatch"></path>
        <path d="M5 35L30 35L30 60L5 60L5 35Z" id="fldctlPreparation"></path>
        <path d="M5 65L30 65L30 90L5 90L5 65Z" id="fldctlStandby"></path>
        <text id="fldctlDispatchText" x="40" y="24" font-size="0.9rem">
          {{ text.fldctlDispatch }}
        </text>
        <text id="fldctlPreparationText" x="40" y="54" font-size="0.9rem">
          {{ text.fldctlPreparation }}
        </text>
        <text id="fldctlStandbyText" x="40" y="84" font-size="0.9rem">
          {{ text.fldctlStandby }}
        </text>
      </defs>
      <g>
        <g>
          <use
            xlink:href="#fldctlDispatch"
            opacity="1"
            fill-opacity="1"
            :fill="color.fldctlDispatch"
            stroke="#000000"
            stroke-width="3"
            stroke-opacity="1"
          ></use>
          <use
            xlink:href="#fldctlDispatchText"
            opacity="1"
            fill="#000000"
            fill-opacity="1"
          ></use>
        </g>
        <g>
          <use
            xlink:href="#fldctlPreparation"
            opacity="1"
            fill-opacity="1"
            :fill="color.fldctlPreparation"
            stroke="#000000"
            stroke-width="3"
            stroke-opacity="1"
          ></use>
          <use
            xlink:href="#fldctlPreparationText"
            opacity="1"
            fill="#000000"
            fill-opacity="1"
          ></use>
        </g>
        <g>
          <use
            xlink:href="#fldctlStandby"
            opacity="1"
            fill-opacity="1"
            :fill="color.fldctlStandby"
            stroke="#000000"
            stroke-width="3"
            stroke-opacity="1"
          ></use>
          <use
            xlink:href="#fldctlStandbyText"
            opacity="1"
            fill="#000000"
            fill-opacity="1"
          ></use>
        </g>
      </g>
    </svg>
  </div>
</template>
<!-- ----------------------------------------------- -->
<script>
import Color from "../../../scss/color.scss";

/**
 * 川の防災情報 地図画面 地図凡例ダイアログ 水防警報
 * LegendFldctl.vue
 * @author LIS
 */
export default {
  name: "legend-fldctl",
  data() {
    return {
      /** 色 */
      color: {
        fldctlDispatch: Color.rwFldctlDispatch,
        fldctlPreparation: Color.rwFldctlPreparation,
        fldctlStandby: Color.rwFldctlStandby,
      },
      /** 文字列リソース */
      text: {
        fldctlDispatch: "出動",
        fldctlPreparation: "準備",
        fldctlStandby: "待機",
      },
    };
  },
};
</script>
